module.exports = __webpack_public_path__ + "media/lobby_normal3.82cd20fb.mp3";